import NumberFormat from "react-number-format"
import { Input } from "./input"

export const InputNumber = (props) => {
  return <NumberFormat {...props} customInput={Input} />
}
